import { Link } from 'react-router'

const REPORTS = [
  { to: '/giganten',   title: 'Die Giganten 2026', text: 'BlackRock, Vanguard, State Street, Blackstone, Apollo, KKR — wer das Geld bewegt.', date: 'Okt 2026' },
  { to: '/geopolitik', title: 'Geopolitik 2026',   text: 'Globale Risiken, Handel und Konfliktherde im Überblick.',                         date: 'Sep 2026' },
]

export default function Archiv() {
  return (
    <main className="max-w-[1200px] mx-auto px-4 sm:px-5 py-8">
      <span className="font-mono text-[10px] font-bold tracking-[0.18em] text-accent">ARCHIV</span>
      <h1 className="text-[26px] font-bold text-t1 tracking-tight mt-1">Hintergrund-Reports</h1>
      <div className="grid gap-3 mt-6 md:grid-cols-2">
        {REPORTS.map(r => (
          <Link key={r.to} to={r.to} className="card p-5 block">
            <div className="font-mono text-[10px] text-t3">{r.date}</div>
            <h2 className="text-[16px] font-semibold text-t1 mt-1">{r.title}</h2>
            <p className="text-[13px] text-t2 mt-1">{r.text}</p>
          </Link>
        ))}
      </div>
    </main>
  )
}
